module.exports = "/images/veil-5.jpg";